import gql from 'graphql-tag'

const getGenders = schema => gql`query getGenders($isSpanish: Boolean!) {
    pdt_gender {
      code
      description @skip(if: $isSpanish)
      description: description_us_es @include(if: $isSpanish)
      recordorder
    }
  }`

export default getGenders
